// eslint-disable-next-line import/prefer-default-export
export const DEFAULT_LANGUAGE_NAME = 'EN';
export const ESCAPE_KEY = 'Escape';
